import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import { PlacementEnvironmentListResponseData } from "../../types/placement-environment";
import { QueryParams } from "../../types/base";
import { toQueryString } from "../../../common/utils";

export const getData = async (params: QueryParams) => {
  const { data } = await api.get<PlacementEnvironmentListResponseData>(
    `/placement-environments${toQueryString(params)}`,
  );

  return data;
};

export const usePlacementEnvironments = (
  params: QueryParams,
): QueryObserverBaseResult<PlacementEnvironmentListResponseData> => {
  const { data, ...props } = useQuery(
    queryKeys.placementEnvironmentListPage(params),
    () => getData(params),
  );
  return { data, ...props };
};
